import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/fonts.scss";
import "./index.css";
import App from "./App.tsx";
import { initNewRelic } from "./config/newrelic";
import ErrorBoundary from "./components/shared/ErrorBoundary";
// import TestErrorComponent from "./components/shared/TestErrorComponent";

// Initialize New Relic Browser Agent
initNewRelic();

ReactDOM.createRoot(document.getElementById("insole-customizer-root")!).render(
  <React.StrictMode>
    <ErrorBoundary errorContext={{ page: 'CustomInsole' }}>
      <App />
      {/* <TestErrorComponent /> */}
    </ErrorBoundary>
  </React.StrictMode>
);
